export const readFileAsText = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve((reader.result as string) || '')
    reader.onerror = () => reject()
    reader.readAsText(file)
  })

export const isXmlFile = (file: File): boolean => {
  const fileName = file.name.toLowerCase()
  const mimeType = file.type.toLowerCase()

  return (
    fileName.endsWith('.xml') ||
    mimeType === 'text/xml' ||
    mimeType === 'application/xml'
  )
}
